/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Bottom_Right_LabelInputs */



/**
* | output |
* | --- |
* | "Bottom Right" |
*
* @param {Style_Guide_Manager_Position_Bottom_Right_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_bottom_right_label = /** @type {((inputs?: Style_Guide_Manager_Position_Bottom_Right_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Bottom_Right_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas droit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे दाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior direito")
	return /** @type {LocalizedString} */ ("Bottom Right")
});